import {
  type GetProjectsListResponseType,
  USER_ROLES,
} from "@nlc/shared-types";
import { useQuery } from "@tanstack/react-query";

import { useUser } from "@/hooks/useUser";
import apiClient from "@/lib/api/client";

export function useGetProjectsList({
  direction,
  group,
  itemsPerPage,
  page,
  search,
  sortBy,
}: {
  direction: "ascending" | "descending";
  group?: string;
  itemsPerPage: number;
  page: number;
  search?: string;
  sortBy: string;
}) {
  const { data: user } = useUser();

  const searchParams = {
    direction,
    group,
    itemsPerPage,
    page,
    search,
    sortBy,
  };

  const shouldEnableQuery =
    user?.user?.roleName &&
    [
      USER_ROLES.CUSTOMER_SUCCESS,
      USER_ROLES.DESIGNER,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.TEAM_LEADER,
    ].includes(user.user.roleName);

  return useQuery<GetProjectsListResponseType>({
    enabled: Boolean(shouldEnableQuery),
    queryFn: async () => {
      const params = new URLSearchParams({
        direction: direction === "ascending" ? "asc" : "desc",
        itemsPerPage: itemsPerPage.toString(),
        page: page.toString(),
        sortBy: sortBy ?? "createdAt",
        ...(search && { search }),
        ...(group && { group }),
      });

      return await apiClient.url(`/projects?${params.toString()}`).get().json();
    },
    queryKey: ["projects", searchParams],
    refetchOnWindowFocus: false,
    staleTime: 30_000,
  });
}
